import { Stack } from "@mui/material";

import {
  EmbeddedAnalyticsPage,
  EmbeddedDashboard,
} from "components/EmbeddedAnalytics";
import { EmbeddedDashboardName } from "components/EmbeddedAnalytics/types";
import { ErrorTypography } from "components/ErrorTypography";
import {
  useEmbeddedAnalyticsAccess,
  useIsDemoParticipant,
  useSubscriptionStatus,
} from "hooks";

import { TrackingSheetUpgradePage } from "../TrackingSheetUpgradePage";

export function ShipmentTrackingDashboardPage() {
  /*
  Renders the howdygo demo to subscriptions that do not have a data package in their sub,
  However, some users may have the data package turned on
  (even if their subscription does not allow it - e.g. if sales/operations is giving them a demo
  with the 'real' data product)
  */
  const isDemoParticipant = useIsDemoParticipant();
  const { subscription } = useSubscriptionStatus();
  const { hasAccess, error } = useEmbeddedAnalyticsAccess({
    dashboard: EmbeddedDashboardName.SHIPMENT_TRACKING_SHEET,
  });

  // Demo participants always see the HowdyGo walkthrough, regardless of their
  // (typically absent) subscription/analytics access.
  if (isDemoParticipant) {
    return <TrackingSheetUpgradePage isDemoParticipant />;
  }

  if (subscription === null) {
    return null;
  }

  // One page for every no-access case here: unlike the Company Dashboard, the
  // tracking sheet has no separate "plan covers it but it is not switched on"
  // surface to send people to.
  if (hasAccess === false) {
    return <TrackingSheetUpgradePage />;
  }
  if (hasAccess == null) {
    if (error !== null) {
      return (
        <Stack>
          <ErrorTypography error={error} />
        </Stack>
      );
    }
    return null;
  }

  return (
    <EmbeddedAnalyticsPage
      dashboard={
        <EmbeddedDashboard
          dashboard={EmbeddedDashboardName.SHIPMENT_TRACKING_SHEET}
        />
      }
    />
  );
}
